import {
  AlertModule,
  LayoutModule,
  ModalModule,
  SimpleMessageModule,
  TreeModule,
  WebAppCommonModule,
} from "@allbesmart/web-app-common";
import { WebAppKeycloakAuthModule } from "@allbesmart/web-app-keycloak-auth";
import {
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { ApplicationConfig, importProvidersFrom } from "@angular/core";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideRouter } from "@angular/router";
import {
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  includeBearerTokenInterceptor,
  provideKeycloak,
} from "keycloak-angular";
import { environment } from "../environments/environment";
import { routes } from "./app.routes";

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    importProvidersFrom(
      WebAppCommonModule,
      ModalModule,
      TreeModule,
      AlertModule,
      LayoutModule,
      SimpleMessageModule,
      WebAppKeycloakAuthModule
    ),
    provideAnimationsAsync(),
    provideHttpClient(
      withInterceptors([includeBearerTokenInterceptor]),
      withInterceptorsFromDi()
    ),
    provideKeycloak({
      config: {
        url: environment.keycloak.url,
        realm: environment.keycloak.realm,
        clientId: environment.keycloak.clientId,
      },
      initOptions: {
        checkLoginIframe: false,
      },
      providers: [
        {
          provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
          useValue: [{ urlPattern: /.*/ }],
        },
      ],
    }),
  ],
};
